import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetLastViewedPathQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetLastViewedPathQuery = { __typename?: 'Query', getLastViewedPath: { __typename?: 'LastViewedPath', path: string } };


export const GetLastViewedPath = /*#__PURE__*/ gql`
    query GetLastViewedPath {
  getLastViewedPath {
    path
  }
}
    ` as unknown as DocumentNode<GetLastViewedPathQuery, GetLastViewedPathQueryVariables>;

          

          export const useGetLastViewedPathQuery = (options?:QueryHookOptions<GetLastViewedPathQuery, GetLastViewedPathQueryVariables>) => useQuery(GetLastViewedPath, options);

          

          export type GetLastViewedPathQueryOptions = QueryHookOptions<GetLastViewedPathQuery, GetLastViewedPathQueryVariables>;

          

          export const useGetLastViewedPathLazyQuery = (options?:LazyQueryHookOptions<GetLastViewedPathQuery, GetLastViewedPathQueryVariables>) => useLazyQuery(GetLastViewedPath, options);

          

          export type GetLastViewedPathQueryResult = ReturnType<typeof useGetLastViewedPathQuery>;

          
